import { render, staticRenderFns } from "./ConfigCol.vue?vue&type=template&id=0d61d603&scoped=true&"
import script from "./ConfigCol.vue?vue&type=script&lang=js&"
export * from "./ConfigCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d61d603",
  null
  
)

export default component.exports